  const modTitles = {
    'kv': 'Körperliche Verteidigung',
    'mv': 'Magische Verteidigung',
    'wund': 'Wundschwelle',
    'pr': 'Physische Rüstung',
    'mr': 'Mystische Rüstung',
    'dmg': 'Schadenswurf',
    'hit': 'Trefferwurf'
}

export default modTitles